import { render, staticRenderFns } from "./PeopleData.vue?vue&type=template&id=043b5afb&"
import script from "./PeopleData.vue?vue&type=script&lang=js&"
export * from "./PeopleData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports